import type { EventBusPayload } from "@/modules/event-bus";

import { useQueryClient } from "@tanstack/react-query";

import { isNotificationBroadcastModelDeleteAsyncSuccessPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";
import { getModelApiKey } from "@/modules/model";

import { notifyModelDeleteAsyncActionSuccess } from "./model-delete-async-action-success.helper";

export const useModelDeleteAsyncActionSuccess = () => {
  const { notify } = useAppNotification();
  const queryClient = useQueryClient();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();
  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastModelDeleteAsyncSuccessPayload(payload)) return;
    if (isBroadcastNotificationEnabled("model-deletion")) {
      notifyModelDeleteAsyncActionSuccess({ notify, payload });
    }

    const apiKey = getModelApiKey(payload.models[0].type);
    queryClient.invalidateQueries({
      queryKey: [apiKey, "list"],
    });

    invalidateNotifications("*");
  };

  return { runAction };
};
